import React from 'react'
import qs from 'qs'

import { Helmet } from 'react-helmet'
import { withTranslation } from 'react-i18next'

import Loader from '../../components/Loader'
import Toast from '../../components/Toast'

import { API__PAYMENTS } from '../../api'
import { UTILS__ROUTER__add_query, UTILS__ROUTER__remove_query } from '../../utils/router'
import { NoSubscription, SubscriptionTab } from './components'
import { PageBar } from './components/PageBar'
import { SUBSCRIPTION_TABS } from './constants'
import { BillingHistoryTable } from './components/BillingHistoryTable'

class BillingAndPayments extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,

            tab: SUBSCRIPTION_TABS.subscription,
            tabs: Object.values(SUBSCRIPTION_TABS),

            paymentsLoading: false,
            payments: {
                pagination: {
                    initialPage: 0,
                    perPage: 100,
                    totalPages: 0,
                    offsetPages: 0,
                },
                filter: {
                    sort: 'saleDate,desc',
                },
                content: [],
            },
        }
        this.baseState = this.state
    }

    async componentDidMount() {
        try {
            // Tabs
            const { tabs } = this.state

            const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
            const queryParamsTab = queryParams.tab

            if (tabs.indexOf(queryParamsTab) !== -1) {
                await this.setState({
                    tab: queryParamsTab,
                })
            } else {
                UTILS__ROUTER__remove_query('tab', {
                    history: this.props.history,
                    location: this.props.location,
                })
            }

            const { tab } = this.state

            if (tab === SUBSCRIPTION_TABS.billingHistory) {
                await this.updatePaymentsHistory(true)
            }
        } finally {
            await this.setState({
                isLoading: false,
            })
        }
    }

    async updatePaymentsHistory(clear) {
        try {
            await this.setState({ paymentsLoading: true })

            if (clear) {
                await this.clearPaymentsHistory()
            }

            const {
                payments: { pagination, filter },
            } = this.state

            // Pagination
            const params = {
                perPage: pagination.perPage,
                offsetPages: pagination.offsetPages,
                sort: filter.sort,
            }

            const response = await API__PAYMENTS.GET_PAYMENTS_HISTORY(params)

            await this.setState(prevState => ({
                payments: {
                    ...prevState.payments,
                    content: [...prevState.payments.content, ...response.content],
                    pagination: {
                        ...prevState.payments.pagination,
                        totalPages: response.totalPages,
                    },
                },
            }))
        } finally {
            await this.setState({ paymentsLoading: false })
        }
    }

    clearPaymentsHistory = async () => {
        await this.setState(prevState => ({
            payments: {
                ...prevState.payments,
                content: [],
                pagination: this.baseState.payments.pagination,
            },
        }))
    }

    handleTabClick = target => async evt => {
        evt.preventDefault()
        const { tab } = this.state
        if (target !== tab) {
            if (target === SUBSCRIPTION_TABS.subscription) {
                UTILS__ROUTER__remove_query('tab', {
                    history: this.props.history,
                    location: this.props.location,
                })
            } else {
                UTILS__ROUTER__add_query('tab', target, {
                    history: this.props.history,
                    location: this.props.location,
                })
            }
            await this.setState({
                tab: target,
            })

            if (target === SUBSCRIPTION_TABS.billingHistory) {
                await this.updatePaymentsHistory(true)
            }
        }
    }

    getInvoice = async item => {
        const { t } = this.props
        let invoice = null
        try {
            invoice = await API__PAYMENTS.GET_INVOICE(item.externalOrderReference)
        } catch (err) {
            Toast('error', {
                title: t('_common._notify._failed.title'),
                msg: t('_pages._billing_and_payments.invoice_not_found'),
            })
        }

        if (invoice) {
            window.open().document.write(
                `<iframe src="data:${invoice.data}" 
                        frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`,
            )
        }
    }

    render() {
        const { t } = this.props
        const { isLoading, tab, payments, paymentsLoading } = this.state

        return !isLoading ? (
            <div className="page page--billing_and_payments" data-structure="1">
                <Helmet>
                    <title>{t('_pages._billing_and_payments.title')} | Interacty</title>
                </Helmet>

                <section>
                    <div className="container">
                        <PageBar currentTab={tab} handleTabClick={this.handleTabClick} />

                        {tab === SUBSCRIPTION_TABS.subscription && <SubscriptionTab t={t} />}
                        {tab === SUBSCRIPTION_TABS.billingHistory && paymentsLoading && (
                            <SubscriptionTab className="dim" t={t} />
                        )}
                        {tab === SUBSCRIPTION_TABS.billingHistory && (
                            <BillingHistoryTable payments={payments} getInvoice={this.getInvoice} />
                        )}
                    </div>
                </section>
            </div>
        ) : (
            <Loader text={`${t('_common.data_loading')}...`} />
        )
    }
}

export default withTranslation('translations')(BillingAndPayments)
